<footer class="footer">
    <div class="footer-content justify-content-between">
        <p class="m-b-0">Copyright © 2024 Innovative Tax Relief. All rights reserved.</p>
        <p class="m-b-0">V3.3.12</p>
    </div>
</footer>